import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M9 15l6 -6","key":"svg-1"}]]

const IconSquareForbid2 = createReactComponent('outline', 'square-forbid-2', 'SquareForbid2', __iconNode);

export default IconSquareForbid2;